import { R_ABOUT_US } from '../routes';

const AboutUs = () => import(/* webpackChunkName: "AboutUs" */ '@/views/AboutUs');

export default {
  name: R_ABOUT_US,
  meta: {
    title: 'About us',
  },
  path: '/about-us',
  component: AboutUs,
};
